import React, { useCallback, useMemo } from 'react';
import { DataSetSelector } from 'apps/sigma2-ui/src/data-wizard/components/DataSetSelector';
import { ReadPatternHook } from 'apps/sigma2-ui/src/lib/hooks/useReadPattern';
import { DataSets } from 'libs/end-to-end/src/types/databases/data-sets/data-sets';
import { DataSet } from 'libs/end-to-end/src/types/databases/data-sets/data-set';

export const WorkflowDataSetSelector = ({
  title,
  dataSetId,
  setDataSetId,
  listDataSetsPattern,
  filterFn,
}: {
  title: string;
  dataSetId: string | null;
  setDataSetId: (dataSetId: string | null) => void;
  listDataSetsPattern: ReadPatternHook<DataSets>;
  filterFn?: (dataSet: DataSet) => boolean;
}) => {
  const updateMethod = useCallback(
    (dataSetId: string | null) => {
      setDataSetId(dataSetId);
    },
    [setDataSetId],
  );

  const selectedDataSetId = useMemo(() => dataSetId ?? 'none', [dataSetId]);

  const mergeDataSets = useMemo(() => {
    return listDataSetsPattern.status === 'done'
      ? filterFn
        ? listDataSetsPattern.entity.dataSets.filter(filterFn)
        : listDataSetsPattern.entity.dataSets
      : [];
  }, [filterFn, listDataSetsPattern]);

  return (
    <div className="space-y-6 p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="text-gray-600">Select the data set for integration.</p>
      <DataSetSelector
        dataSetId={selectedDataSetId}
        setDataSetId={updateMethod}
        dataSets={mergeDataSets}
        label="Select a data set"
      />
    </div>
  );
};
